module.exports = __webpack_public_path__ + "img/partner19.9367ecb2.png";